export const REQUIRED_COLS = [
  'MAKE',
  'MODEL',
  'MATERIAL_CATEGORY',
  'TONNAGE',
  'VOLUME',
] as const;

export const TEMPLATE_HEADERS = [...REQUIRED_COLS];

export const MG_SAMPLE_ROW: Record<string, string> = {
  MAKE: 'CAT',
  MODEL: '777G',
  MATERIAL_CATEGORY: 'Ore',
  TONNAGE: '65',
  VOLUME: '24.5',
};

export const validateMGHeaders = (
  fileHeaders: string[]
): { valid: boolean; missing: string[] } => {
  const upper = fileHeaders.map((h) => h.trim().toUpperCase());
  const missing = REQUIRED_COLS.filter((h) => !upper.includes(h));
  return { valid: missing.length === 0, missing };
};
